// extracted by mini-css-extract-plugin
export default {"top":"_i","right":"aj","bottom":"bj","left":"cj","overflowIndicator":"dj"};